const MODULES = {
  crm: {
    title: "CRM",
    subtitle: "Sales pipeline, accounts, contacts, and customer follow-ups.",
    accent: "#2563eb",
    stats: ["Leads", "Deals", "Accounts", "Activities"],
  },
  hrms: {
    title: "HRMS",
    subtitle: "People operations, attendance, onboarding, and employee records.",
    accent: "#059669",
    stats: ["Employees", "Attendance", "Onboarding", "Requests"],
  },
  "finance-admin": {
    title: "Finance/Admin",
    subtitle: "Budgets, approvals, vendors, invoices, and administrative controls.",
    accent: "#d97706",
    stats: ["Budgets", "Invoices", "Vendors", "Approvals"],
  },
  "client-portal": {
    title: "Client Portal",
    subtitle: "Client-facing project updates, requests, documents, and approvals.",
    accent: "#7c3aed",
    stats: ["Clients", "Requests", "Documents", "Approvals"],
  },
  reports: {
    title: "Reports & Analytics",
    subtitle: "Operational dashboards, performance reports, and cross-module insights.",
    accent: "#db2777",
    stats: ["Dashboards", "Reports", "KPIs", "Exports"],
  },
  marketplace: {
    title: "Marketplace & Integrations",
    subtitle: "Connectors, automations, messaging, storage, and external tools.",
    accent: "#475569",
    stats: ["Connectors", "Automations", "Webhooks", "Apps"],
  },
};

export default function SuiteModulePage({ module }) {
  const config = MODULES[module] || MODULES.crm;

  return (
    <div>
      <div
        className="glass-card"
        style={{
          padding: 28,
          borderTop: `3px solid ${config.accent}`,
          marginBottom: 18,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", gap: 18, alignItems: "flex-start" }}>
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, color: config.accent, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>
              Tackl Suite
            </div>
            <h2 style={{ margin: 0, fontSize: 24, lineHeight: 1.2, color: "var(--text)" }}>
              {config.title}
            </h2>
            <p style={{ margin: "8px 0 0", maxWidth: 560, color: "var(--text-2)", fontSize: 14 }}>
              {config.subtitle}
            </p>
          </div>
          <span
            style={{
              padding: "6px 10px",
              borderRadius: 999,
              background: "var(--surface-2)",
              border: "1px solid var(--border)",
              color: "var(--text-2)",
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            Planned
          </span>
        </div>
      </div>

      <div className="summary-grid">
        {config.stats.map((item) => (
          <div key={item} className="summary-card" style={{ borderTop: `3px solid ${config.accent}` }}>
            <div className="summary-card-value" style={{ fontSize: 22, color: "var(--text-3)" }}>
              -
            </div>
            <div className="summary-card-label">{item}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
